/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const MenuLeadsDirectoryIcon = ({
  className,
  style: styleFromProps,
  onClick,
  size,
  color = '#6190B7',
  colorSecondary = '#C9DCEB',
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.5 9.75C35.5 12.3556 34.4414 14.7442 32.7042 16.4542C30.9944 18.1914 28.6058 19.25 26 19.25C25.4843 19.25 24.9686 19.1956 24.48 19.1143L17.4499 13.8486C16.8257 12.6 16.5 11.2156 16.5 9.75C16.5 7.1442 17.5586 4.75563 19.2958 3.04563C21.0056 1.30857 23.3942 0.25 26 0.25C28.6058 0.25 30.9944 1.30857 32.7042 3.04563C34.4414 4.75563 35.5 7.1442 35.5 9.75Z"
        fill={colorSecondary}
      />
      <path
        d="M27 18C27 21.105 24.48 23.625 21.375 23.625C18.27 23.625 15.75 21.105 15.75 18C15.75 15.0074 18.0899 12.5549 21.0374 12.3975L26.865 16.7625C26.9549 17.1675 27 17.5725 27 18Z"
        fill={color}
      />
      <path
        d="M31.5 30.375V34.875H20.25L15.75 24.03C16.4475 23.76 17.2126 23.625 18 23.625H24.75C28.4849 23.625 31.5 26.6399 31.5 30.375Z"
        fill={color}
      />
      <path
        d="M10.125 23.625C13.2316 23.625 15.75 21.1066 15.75 18C15.75 14.8934 13.2316 12.375 10.125 12.375C7.0184 12.375 4.5 14.8934 4.5 18C4.5 21.1066 7.0184 23.625 10.125 23.625Z"
        fill={colorSecondary}
      />
      <path
        d="M15.75 24.03L11.25 34.875H0V30.375C0 26.6399 3.01507 23.625 6.75 23.625H13.5C14.2874 23.625 15.0525 23.76 15.75 24.03Z"
        fill={colorSecondary}
      />
      <path
        d="M31.0502 7.42461V10.1246H28.3502V12.8246H25.6502V10.1246H22.9502V7.42461H25.6502V4.72461H28.3502V7.42461H31.0502Z"
        fill={color}
      />
      <path
        d="M26.8647 16.7625C24.2771 16.3574 22.1172 14.6924 21.0371 12.3975C21.1498 12.375 21.2622 12.375 21.3747 12.375C24.0522 12.375 26.3022 14.2424 26.8647 16.7625Z"
        fill={color}
      />
      <path
        d="M20.25 30.3753V34.8753H11.25V30.3753C11.25 27.4278 13.1176 24.9302 15.75 24.0303C18.3824 24.9302 20.25 27.4278 20.25 30.3753Z"
        fill={color}
      />
    </svg>
  );
};
